module.exports = __webpack_public_path__ + "img/26.022ca595.jpg";